import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SafetyShoesComponent } from './safety-shoes.component';
import { SafetyShoesDetailsComponent } from './safety-shoes-details/safety-shoes-details.component';

const routes: Routes = [
    {
      path: '',
      data: {
        title: 'Safety Shoes'
      },
      children: [
        {
          path: '',
          component: SafetyShoesComponent,
          data: {
            title: 'Home'
          }
        },
        {
          path: ':productName',
          children: [
            {
              path: '',
              component: SafetyShoesDetailsComponent,
              data: { title: 'Shoe Details'}
            }
          ]
        }
      ]
    }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class SafetyShoesRoutingModule { }
